import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overtitle, title, align = "left" }) => (
  <div className={align === "center" ? "text-center" : "text-left"}>
    <Reveal>
      <p className="font-mono-accent text-[11px] uppercase tracking-[0.35em] text-[#D4AF37]">
        {overtitle}
      </p>
    </Reveal>
    <Reveal delay={0.12}>
      <h2 className="font-serif-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white leading-[1.08]">
        {title}
      </h2>
    </Reveal>
  </div>
);
